import Colors from './colors';
import Fonts from './fonts/fontIndex';
export { Colors, Fonts }